<p-toast position="bottom-right" key="br"></p-toast>

<p-accordion [multiple]="true" [activeIndex]="[1,2]">
  <p-accordionTab header="About">
    <p>Render 3D surfaces of option chain open interest:
      Calls (positive), Puts (inverted negative), and Net (Calls - Puts).</p>
  </p-accordionTab>

  <p-accordionTab header="Filters">
    <p-toolbar>
      <form [formGroup]="optionForm" class="p-fluid p-formgrid p-grid">
        <!-- Symbol -->
        <div class="p-field p-col-12 p-md-6">
          <label for="symbol">Symbol <span class="required">*</span></label>
          <input
            pInputText
            id="symbol"
            formControlName="symbol"
            placeholder="Enter symbol (e.g., SPY)"/>
        </div>

        <!-- Include sides -->
        <div class="p-field-checkbox p-col-12 p-md-6">
          <label for="includeCalls">Include Calls</label>
          <p-checkbox id="includeCalls" formControlName="includeCalls" inputId="includeCalls" binary="true"></p-checkbox>

          <label for="includePuts" style="margin-left:1rem;">Include Puts</label>
          <p-checkbox id="includePuts" formControlName="includePuts" inputId="includePuts" binary="true"></p-checkbox>
        </div>

        <!-- Date window -->
        <div class="p-field p-col-12 p-md-6">
          <label for="fromDate">From Date (yyyy-MM-dd)</label>
          <input pInputText id="fromDate" formControlName="fromDate" placeholder="YYYY-MM-DD"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="toDate">To Date (yyyy-MM-dd)</label>
          <input pInputText id="toDate" formControlName="toDate" placeholder="YYYY-MM-DD"/>
        </div>

        <!-- Strike count around ATM -->
        <div class="p-field p-col-12 p-md-6">
          <label for="strikeCount">Strike Count Around ATM</label>
          <input pInputText id="strikeCount" type="number" formControlName="strikeCount" placeholder="e.g., 20"/>
        </div>

        <!-- Nearest N expirations -->
        <div class="p-field p-col-12 p-md-6">
          <label for="nearestExpirations">Show Nearest N Expirations</label>
          <input pInputText id="nearestExpirations" type="number" formControlName="nearestExpirations" placeholder="e.g., 6"/>
        </div>

        <!-- Form Actions -->
        <div class="p-field-buttons">
          <button pButton icon="pi pi-search" label="Submit" (click)="submit()" [disabled]="loading"></button>
          <button pButton icon="pi pi-filter-slash" label="Reset" (click)="resetForm()" [disabled]="loading"></button>
        </div>
      </form>
    </p-toolbar>
    <div *ngIf="loading" class="loading">Loading option chain...</div>
    <div *ngIf="errorMsg" class="p-error">{{ errorMsg }}</div>
  </p-accordionTab>

  <p-accordionTab header="Graphs">
    <form [formGroup]="dataDisplayForm" class="p-fluid p-formgrid p-grid">
      <div class="p-field-checkbox p-col-12">
        <label for="showRawData">Show Raw Data</label>
        <p-checkbox id="showRawData" formControlName="showRawData" inputId="showRawData" binary="true"></p-checkbox>

        <label for="showPlane" style="margin-left:1rem;">Show Underlying Plane</label>
        <p-checkbox id="showPlane" formControlName="showPlane" inputId="showPlane" binary="true"></p-checkbox>

        <label for="showCombinedTooltips" style="margin-left:1rem;">Net Tooltip: Show Calls/Puts</label>
        <p-checkbox id="showCombinedTooltips" formControlName="showCombinedTooltips" inputId="showCombinedTooltips" binary="true"></p-checkbox>
      </div>

      <div class="p-field-checkbox p-col-12">
        <label for="showCalls">Show Calls</label>
        <p-checkbox id="showCalls" formControlName="showCalls" inputId="showCalls" binary="true"></p-checkbox>

        <label for="showPuts" style="margin-left:1rem;">Show Puts</label>
        <p-checkbox id="showPuts" formControlName="showPuts" inputId="showPuts" binary="true"></p-checkbox>

        <label for="showNet" style="margin-left:1rem;">Show Net</label>
        <p-checkbox id="showNet" formControlName="showNet" inputId="showNet" binary="true"></p-checkbox>
      </div>
    </form>

    <div *ngIf="showRawDataBool">
      <ngx-json-viewer [json]="rawChain" [expanded]="false"></ngx-json-viewer>
    </div>

    <div class="container">
      <plotly-plot [data]="graphData" [layout]="graphLayout"></plotly-plot>
    </div>
  </p-accordionTab>
</p-accordion>
